export default "__VITE_ASSET__BcLgWnHE__"